import React from "react";
import { Container } from "react-bootstrap";

export default function Privacy() {
  return (
    <Container className="py-5">
      <h2>Privacy Policy</h2>

      <p className="mt-3">
        TickTickGo values your privacy. We collect minimal user data required to
        provide and improve our services.
      </p>

      <h4 className="mt-4">Information We Collect</h4>

      <p>
        When you sign in using Google Login, we request access to your basic
        Google profile information. We store only the following account
        information:
      </p>

      <ul>
        <li>First Name</li>
        <li>Last Name</li>
        <li>Email Address</li>
      </ul>

      <p>
        If you choose to connect your Google Calendar, we request access to your
        calendar only after you explicitly grant permission. This access is used
        solely to display your upcoming events and meetings within TickTickGo
        and to allow you to create new calendar events on your behalf.
      </p>

      <h4 className="mt-4">How We Use Your Information</h4>

      <p>Your information is used only to:</p>

      <ul>
        <li>Authenticate your identity using Google Sign-In.</li>
        <li>Create and manage your TickTickGo account.</li>
        <li>
          Display your upcoming Google Calendar events when you connect your
          calendar.
        </li>
        <li>
          Create Google Calendar events that you choose to create through
          TickTickGo.
        </li>
        <li>Provide customer support and account-related communications.</li>
      </ul>

      <p>
        We do not use your Google user data for advertising, profiling,
        marketing, or any purpose unrelated to the features you choose to use.
      </p>

      <h4 className="mt-4">Information Sharing, Transfer, and Disclosure</h4>

      <p>
        TickTickGo does <strong>not</strong> sell, rent, trade, share, transfer,
        or disclose your Google user data to any third party.
      </p>

      <p>
        Google user data, including your Google profile information and Google
        Calendar data, is used solely to provide the features you explicitly
        authorize within TickTickGo, such as authentication, viewing your
        upcoming calendar events, and creating calendar events on your behalf.
      </p>

      <p>
        We do not share your Google user data with advertisers, marketing
        partners, analytics providers, data brokers, or any other third
        parties.
      </p>

      <p>
        We do not transfer or disclose your Google user data to any external
        organization except in the following limited circumstances:
      </p>

      <ul>
        <li>
          When required by applicable law, regulation, legal process, or a valid
          governmental request.
        </li>
        <li>
          When necessary to detect, prevent, or address fraud, security, or
          technical issues.
        </li>
        <li>
          When necessary to protect the rights, property, or safety of
          TickTickGo, our users, or the public, as permitted by law.
        </li>
      </ul>

      <p>
        Any authorized service providers that assist in operating our
        infrastructure, such as secure cloud hosting providers, may process data
        solely on our behalf under strict confidentiality and security
        obligations. These providers do not have permission to use your Google
        user data for any purpose other than providing the contracted services.
      </p>

      <p>
        TickTickGo does not use or transfer Google user data for purposes
        unrelated to providing or improving the user-facing features requested
        by you.
      </p>

      <h4 className="mt-4">Google Calendar Data Storage</h4>

      <p>
        TickTickGo does not permanently store your Google Calendar events, event
        descriptions, attendees, or other calendar metadata.
      </p>

      <p>
        Calendar information is retrieved from Google only to display your
        upcoming events within the application or to create calendar events that
        you request.
      </p>

      <p>
        The only calendar-related information stored by TickTickGo is the
        meeting URL associated with meetings created through our platform. This
        enables meeting management and joining from within TickTickGo.
      </p>

      <h4 className="mt-4">Data Retention and Deletion</h4>

      <p>
        We retain your first name, last name, and email address only while your
        TickTickGo account remains active.
      </p>

      <p>
        Meeting URLs created through TickTickGo are retained while they are
        associated with your account or scheduled meetings.
      </p>

      <p>Google Calendar event data is not permanently stored by TickTickGo.</p>

      <p>
        If you delete your account or request account deletion, your stored
        personal information and associated meeting URLs are removed from our
        systems within a reasonable period unless we are legally required to
        retain certain information.
      </p>

      <h4 className="mt-4">Security</h4>

      <p>
        We employ appropriate technical and organizational safeguards to protect
        your information from unauthorized access, disclosure, alteration, or
        destruction.
      </p>

      <ul>
        <li>
          All communication with Google and our servers is encrypted using
          HTTPS/TLS.
        </li>
        <li>Personal information is stored on secured servers.</li>
        <li>
          Access to stored user information is restricted to authorized
          personnel.
        </li>
        <li>
          Only the minimum Google data required to provide requested features is
          accessed.
        </li>
        <li>
          We periodically review our security practices to help maintain the
          confidentiality and integrity of user data.
        </li>
      </ul>

      <h4 className="mt-4">Google API Services Compliance</h4>

      <p>
        TickTickGo's use and transfer of information received from Google APIs
        adheres to the Google API Services User Data Policy, including the
        Limited Use requirements.
      </p>

      <h4 className="mt-4">Your Consent</h4>

      <p>
        By using Google Login or our platform, you consent to the collection and
        use of information as described in this policy.
      </p>
    </Container>
  );
}